import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import UsersContainer from '../containers/users/UsersContainer';
import HomeContainer from '../containers/home/HomeContainer';
import WindowedApp from '../components/windowed/WindowedApp';
import LeadTrackerContainer from '../containers/leadtracker/LeadTrackerContainer';
import PMWindowApp from '../components/projectmanager/PMWindowApp';
import PMRoot from '../components/projectmanager/new/PMRoot';
import ScaffoldApp from '../components/scaffold/ScaffoldApp';

class Router extends Component {
	render() {
		return <BrowserRouter>
			<Route render={({ location }) => (
				<Switch location={location} key={location.key}>
					<PrivateRoute exact name="index" path="/" component={HomeContainer} {...this.props} />
					<PrivateRoute exact name="home" path="/home/" component={HomeContainer} {...this.props} />
					<PrivateRoute exact name='users' path='/users/' component={UsersContainer} {...this.props} />
					<PrivateRoute exact name='leadtracker' path='/leadtracker/' component={LeadTrackerContainer} {...this.props} />
					<PrivateRoute exact name='windowed' path='/windowed/' component={WindowedApp} {...this.props} />
					<PrivateRoute exact name='projectmanager' path='/projectmanager/' component={PMRoot} {...this.props} />
					<PrivateRoute exact name='projectmanager' path='/projectmanager/desktop' component={PMWindowApp} {...this.props} />
					<PrivateRoute exact name='projectmanager' path='/projectmanager/scaffold' component={ScaffoldApp} {...this.props} />
				</Switch>
			)} />
		</BrowserRouter>
	}

}
function mapStateToProps(state) {
	return {
		dispatchConfig: state.dispatchConfig
	}
}

export default connect(mapStateToProps, null)(Router);


// WEBPACK FOOTER //
// ./src/config/Router.jsx